// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//= require jquery

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

Rails.start()
Turbolinks.start()
ActiveStorage.start()

function changeDisplay() {
    // このフォームがあるページ（会員登録・プロフィール編集）でのみ動かす
    var form = document.Form1;
    if (!form || !form["user[syurui]"] || !form["inputNumber"]) return;

    var inputNumber = document.getElementById('input-number');
    if (!inputNumber) return;

    if ( form["user[syurui]"][2].checked ) {
        form["inputNumber"].disabled = false;
        inputNumber.style.display = "inline";
    } else {
        form["inputNumber"].disabled = true;
        inputNumber.style.display = "none";
    }
}
window.addEventListener('load', changeDisplay);